import BaseAPI from "../api";

const path: string = "projects";
const pathTracking = "tracking-projects";
const draft: string = "draft-projects";

export type detailIndicator = {
  idIndicators: number | undefined;
  indicatorsName: string;
  percent: number;
  min1: number;
  max1: number;
  description1: string;
  min2: number;
  max2: number;
  description2: string;
  min3: number;
  max3: number;
  description3: string;
  min4: number;
  max4: number;
  description4: string;
  min5: number;
  max5: number;
  description5: string;
};

export type detailResponsible = {
  idEmployee: number;
  percent: number | null;
};

export type detailActivity = {
  detailActivities: [
    {
      projectActivitiesName: string;
      projectActivitiesDesc: string;
      idMainResponsible: number;
      percentMainResponsible: number;
      detailWorkPeriod: [
        {
          startDate: string;
          endDate: string;
        }
      ];
      detailDisbursement: [
        {
          endDate: string;
          budget: number;
          paid: number;
          unpaid: number;
        }
      ];
      detailResponsible: [
        {
          idEmployee: number;
          percent: number;
        }
      ];
      detailIndicators: [
        {
          idIndicators: number;
          indicatorsName: string;
          percent: number;
          min1: number;
          max1: number;
          min2: number;
          max2: number;
          min3: number;
          max3: number;
          min4: number;
          max4: number;
          min5: number;
          max5: number;
        }
      ];
    }
  ];
};

export type detailBudget = {
  idBudget: number | null;
  projectBudget: number | string;
  equipmentBudget: number | string;
  extraBudget: number | string;
  reducedBudget: number | string;
  remark: string;
  sumBudget: number | string;
};
export type detailWorkPeriod = {
  startDate: string;
  endDate: string;
};
export type detailDepartment = {
  endDate: string;
  budget: number | string;
  paid: number | string;
  unpaid: number | string;
};
export type createTabs = {
  sumAllBudget?: string | any;
  sumAllPaid?: string | any;
  sumAllUnpaid?: string | any;
  projectActivitiesDesc?: string;
  projectActivitiesName?: string;
  percentMainResponsible?: number;
  projectDesc?: string;
  detailWorkPeriod: detailWorkPeriod[];
  detailDisbursement: detailDepartment[];
  detailBudget: detailBudget[];
  detailResponsible: detailResponsible[];
  detailIndicators: detailIndicator[];
};
export interface createProject {
  idDepartment: number | null;
  idFiscalYear: number | null;
  idStrategy: number | null;
  idPlan: number | null;
  projectName: string;
  idType: number | null;
  projectDesc: string;
  idTactics: number | null;
  idClusters: number;
  idMainResponsible: number;
  percentMainResponsible: number;
  projectStartDate: string;
  projectEndDate: string;
  projectStatus: string;
  idStatus: number;
  isPublic: boolean;
  canCancelCancel?:boolean;
  detailWorkPeriod: detailWorkPeriod[];
  detailDisbursement: detailDepartment[];
  detailBudget: detailBudget[];
  detailResponsible: detailResponsible[];
  detailIndicators: detailIndicator[];
  detailActivity?: detailActivity[];
  tabs: createTabs[];
}

interface createProjectAccept {
  projectName: string;
  projectDesc: string;
  idFiscalYear: number;
  idStrategy: number;
  idTactics: number;
  idPlan: number;
  idType: number;
  idClusters: number;
  idMainResponsible: number;
  percentMainResponsible: number;
  projectStartDate: string;
  projectEndDate: string;
  projectStatus: string;
  idStatus: number;
  isPublic: boolean;
  detailWorkPeriod: detailWorkPeriod[];
  detailDisbursement: detailDepartment[];
  detailBudget: detailBudget[];
  detailResponsible: detailResponsible[];
  detailIndicators: detailIndicator[];
  detailActivity: detailActivity[];
}
export interface updateProject {
  projectName: string;
  projectDesc: string;
  idFiscalYear: number;
  idStrategy: number;
  idTactics: number;
  idType: number;
  idClusters: number;
  idMainResponsible: number;
  percentMainResponsible: number;
  projectStartDate: string;
  projectEndDate: string;
  projectStatus: string;
  idStatus: number;
  idPlan: number;
  isPublic: boolean;
}

export interface getProject {
  format?: string;
  page?: number;
  limit?: number;
  keyword?: string;
  idFiscalYear?: number;
  idDepartment?: number;
  idStrategy?: number;
  idTactics?: number;
  idPlan?: number;
  idType?: number;
  idClusters?: number;
  idBudget?: number;
  idStatus?: number;
  startDate?: string;
  endDate?: string;
  sortType?: string;
  sortBy?: string;
}

type projectStatusType = {
  idType?: number;
};

type updatePublic = {
  isPublic: boolean;
};

export class ProjectApi extends BaseAPI {
  static createProject(props: createProjectAccept): Promise<any> {
    return this.api.post(`${path}`, props).then((res) => res);
  }
  static getProject(props: getProject): Promise<any> {
    return this.api.get(`${path}`, { params: { ...props } }).then((res) => res);
  }
  static updateProject(idProject: number, props: updateProject): Promise<any> {
    return this.api.patch(`${path}/${idProject}`, props).then((res) => res);
  }
  static getDetailProject(idProject: number): Promise<any> {
    return this.api.get(`${path}/${idProject}`).then((res) => res);
  }
  static getTrackingProject(props: getProject): Promise<any> {
    return this.api
      .get(`${pathTracking}`, { params: { ...props } })
      .then((res) => res);
  }
  static getDetailTrackingProject(idProject: number): Promise<any> {
    return this.api.get(`${path}/${idProject}`).then((res) => res);
  }
  static updateTrackingProject(idProject: number, prop: any): Promise<any> {
    return this.api
      .patch(`${pathTracking}/${idProject}`, prop)
      .then((res) => res);
  }
  static deleteProject(idProject: number): Promise<any> {
    return this.api.patch(`${path}/${idProject}/delete`).then((res) => res);
  }

  // status
  static getProjectStatus(props: projectStatusType): Promise<any> {
    return this.api
      .get(`project-status`, { params: { ...props } })
      .then((res) => res);
  }
  static getAllProjectStatus(): Promise<any> {
    return this.api.get(`all-project-status`).then((res) => res);
  }

  static getProjectTrack(): Promise<any> {
    return this.api.get(`project-track`).then((res) => res);
  }

  static updateDraftProjectDetail(idProject: number, props: any): Promise<any> {
    return this.api.patch(`${draft}/${idProject}`, props).then((res) => res);
  }

  // ยกเลิกการยกเลิกโครงการ
  static cancelCancelProject(id_project:number):Promise<any>{
    return this.api.patch(`${path}/${id_project}/cancel-cancel`)
  }

  // tracking project
  static updateIsPublicProject(
    idProject: number,
    props: updatePublic
  ): Promise<any> {
    return this.api
      .patch(`${pathTracking}/${idProject}/public`, props)
      .then((res) => res);
  }
  static updateCloseTrackingProject(idProject: number): Promise<any> {
    return this.api
      .patch(`${pathTracking}/${idProject}/close`)
      .then((res) => res);
  }
  static updateCancelTrackingProject(idProject: number): Promise<any> {
    return this.api
      .patch(`${pathTracking}/${idProject}/cancel`)
      .then((res) => res);
  }
  static updateCancelCloseTrackingProject(idProject: number): Promise<any> {
    return this.api
      .patch(`${pathTracking}/${idProject}/cancel-close`)
      .then((res) => res);
  }

  // FILE
  static excelExport(props: getProject): Promise<any> {
    return this.api
      .get(`${path}/file`, {
        params: { ...props },
        responseType: "arraybuffer",
      })
      .then((res) => res);
  }
  static excelExportTracking(props: getProject): Promise<any> {
    return this.api
      .get(`${pathTracking}/file`, {
        params: { ...props },
        responseType: "arraybuffer",
      })
      .then((res) => res);
  }

  // PUBLIC
  static publicData(props: getProject): Promise<any> {
    return this.api
      .get(`public-projects`, { params: { ...props } })
      .then((res) => res);
  }
  static publicAllProjectStatus(): Promise<any> {
    return this.api.get(`public-project-status`).then((res) => res);
  }
  static publicProjectType(idFiscalYear: number): Promise<any> {
    return this.api.get(`public-project-type`, { params: { idFiscalYear: idFiscalYear } })
  }
  static publicDepartmentData():Promise<any>{
    return this.api.get(`public-department`);
  }

  // เอกสารครุภัรฑ์
  static importEquipment(file: FormData): Promise<any> {
    return this.api
      .post(`${pathTracking}/import-equipment`, file, {
        headers: { "Content-Type": "multipart/form-data" },
      })
      .then((res) => res);
  }

  
}
